export const getCardType = (cardType) => {
  const cardBinMap = {
    810500: 'Link card (formerly Plus! card)',
    810501: 'Link card (formerly Plus! card)',
    810800: 'NTUC card',
    820100: 'OCBC Plus! Visa Credit/Debit card',
    830100: 'OCBC NTUC Visa Credit/Debit card',
    810300: 'nEbO card',
    810503: 'NTUC Social Membership card',
    830200: 'NTUC Link Credit/Debit card',
    820200: 'Trust Link Credit/Debit card',
  };
  return cardBinMap[cardType] ? cardBinMap[cardType] : 'Link card';
};

export const replaceableCardTypeMap = {
  810501: true,
  810500: true,
  810300: false,
  810800: true,
  810503: true,
  820100: false,
  830100: false,
  820200: false,
  830200: false,
};

export const cardReplacementText = {
  810300: 'Need to replace your card? Email Customer Support at nEbOcso2@nEbO.com.sg',
  820100: 'Need to replace your card? Call OCBC at 1800 363 3333',
  830100: 'Need to replace your card? Call OCBC at 1800 363 3333',
  820200:
    'You can replace your card via the Trust app or call Trust at +65 313 TRUST (+65 313 87878)',
  830200:
    'You can replace your card via the Trust app or call Trust at +65 313 TRUST (+65 313 87878)',
};

export const getCardFace = (cardType, isRefreshedCardFace) => {
  const defaultLinkCardFace = isRefreshedCardFace
    ? 'https://media.nedigital.sg/linkpass/images/bafe4335-d43a-4069-a737-87459b7a6954/link_card.png'
    : 'https://media.nedigital.sg/linkpass/images/1e5fa3bd-17e8-4f84-a5df-8304684083a8/plus_card.png';

  const cardFaceMap = {
    810501: defaultLinkCardFace,
    810500: defaultLinkCardFace,
    810300: isRefreshedCardFace
      ? 'https://media.nedigital.sg/linkpass/images/e1e3971e-fad2-440d-bf80-ed88a0d8475d/ntuc_nebo_link_card.png'
      : 'https://media.nedigital.sg/linkpass/images/75957183-75e0-4bdc-bcd4-bd6ab27719e9/ntuc_nebo_plus_card.png',
    810800: isRefreshedCardFace
      ? 'https://media.nedigital.sg/linkpass/images/dcca2d83-60c8-4091-ac7f-e0ff0fc30568/ntuc_link_card.png'
      : 'https://media.nedigital.sg/linkpass/images/4767ce2c-522c-42d4-ad84-ab8417bc2941/ntuc_link_plus_card.png',
    810503: defaultLinkCardFace,
    820100:
      'https://media.nedigital.sg/linkpass/images/d789acb0-0a4f-4dcb-848e-6a2488bc589a/plus_visa_card.png',
    830100:
      'https://media.nedigital.sg/linkpass/images/0c9f9572-2a95-4ad5-b273-e061718adfe9/ntuc_plus_visa_card.png',
    820200:
      'https://media.nedigital.sg/linkpass/images/b6b56d05-8fd3-4f35-ad1e-b32d008e446a/link_trust_visa_card.png',
    830200:
      'https://media.nedigital.sg/linkpass/images/7c580e3b-f9fd-41a0-ab3f-d00bce0d4bce/ntuc_link_trust_visa_card.png',
  };
  return cardFaceMap[cardType] ? cardFaceMap[cardType] : defaultLinkCardFace;
};

export const isOcbcCard = (cardType) => {
  return cardType === '820100' || cardType === '830100';
};

export const hasLinkCard = (cards) => {
  const linkCardTypes = ['810501', '810500', '810503', '810800', '810300', '820200', '830200'];
  for (const card of cards) {
    if (linkCardTypes.includes(card.cardType)) {
      return true;
    }
  }
  return false;
};
